<template>
  <div class="relative">
    <el-badge
      :value="badgeValue"
      :hidden="unreadCount <= 0"
      :max="99"
      class="notice-badge"
    >
      <button
        class="h-10 w-10 rounded-full hover:bg-gray-50 transition-colors group inline-flex items-center justify-center"
        title="消息提醒"
        @click="openDrawer"
      >
        <el-icon class="text-xl text-gray-500 group-hover:text-gray-900 transition-colors"><Bell /></el-icon>
      </button>
    </el-badge>

    <NoticeDrawer
      v-model="drawerVisible"
      :unread-count="unreadCount"
      @refresh-count="refreshUnreadCount"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { Bell } from '@element-plus/icons-vue'
import { getNoticeUnreadCount } from '../api/notice'
import NoticeDrawer from './NoticeDrawer.vue'

const drawerVisible = ref(false)
const unreadCount = ref(0)
let timer: number | undefined

const badgeValue = computed(() => (unreadCount.value > 99 ? '99+' : unreadCount.value))

const refreshUnreadCount = async () => {
  try {
    const res = await getNoticeUnreadCount()
    unreadCount.value = Number(res.data || 0)
  } catch {
    unreadCount.value = 0
  }
}

const openDrawer = async () => {
  drawerVisible.value = true
  await refreshUnreadCount()
}

onMounted(() => {
  refreshUnreadCount()
  timer = window.setInterval(refreshUnreadCount, 60000)
})

onBeforeUnmount(() => {
  if (timer) {
    window.clearInterval(timer)
  }
})
</script>

<style scoped>
.notice-badge :deep(.el-badge__content) {
  right: 8px;
  top: 8px;
}
</style>
